<script setup>
import notification from "@/utils/plugins/NotificationService";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import MaterialDeliveryDialog from "@/components/shared/Material/MaterialDeliveryDialog.vue";
import SharedDeleteConfirmDialog from "@/components/shared/SharedDeleteConfirmDialog.vue";
import { computed, onMounted, ref } from "vue";
import { useUiStore } from "@/app/stores/uiStore";
import { filterByNormalizedText } from "@/utils/textSearch";


// Icon
import IconBlueBox from '@/components/icons/IconBlueBox.vue'


// Services
import MaterialService from '@/api/services/materialAssignment.service';
import MaterialTypeService from '@/api/services/materialType.service';
import EmployeeService from '@/api/services/employee.service';

const selectedDateAssigned = ref([])
const selectedDateReturned = ref([])

const materialDelivery = ref(false);
const showModalDelete = ref(false);

const employees = ref([])
const employeeSearchQuery = ref('');

const filteredMaterial = ref();
const selectedMaterial = ref();
const page = ref(1);
const itemsPerPage = ref(30);
const totalResults = ref(0);
const params = ref({})
const serialTag = ref('');

const materialType = ref();

const uiStore = useUiStore();

const asignmentStatus = ref();
const statusTypes = ref([
  {
    name: "Asignación confirmada",
    value: "assigned"
  },
  {
    name: "Asignado",
    value: "pending"
  },
  {
    name: "Devolución solicitada",
    value: "returnRequest"
  },
  {
    name: "Devolución completada",
    value: "returned"
  },
]);

const materialTypes = ref([]);

const employee = ref();
const filteredEmployees = computed(() => {
  return filterByNormalizedText(employees.value, employeeSearchQuery.value, employee => employee.fullName);
});

onMounted(() => {
  params.value = {
    page: page.value,
    itemsPerPage: itemsPerPage.value,
    'order[assignedAt]': "DESC"
  }
  getMaterials();
  getEmployees();
  getMaterialsTypes();
})

const search = () => {
  params.value = {
    page: page.value,
    itemsPerPage: itemsPerPage.value,
    'order[assignedAt]': "DESC"
  }
  let temp = employees.value.find(emp => emp.fullName === employee.value);
  if (temp && temp.id) {
    params.value['employee.id'] = temp.id;
  }
  if (materialType.value) {
    params.value['material.type.id'] = materialType.value;
  }
  if (serialTag.value) {
    params.value['material.serialTag'] = serialTag.value;
  }
  if (selectedDateAssigned.value != null && selectedDateAssigned.value.length > 0) {
    params.value['assignedAt[after]'] = selectedDateAssigned.value[0];
    params.value['assignedAt[before]'] = selectedDateAssigned.value[1];
  }
  if (selectedDateReturned.value != null && selectedDateReturned.value.length > 0) {
    params.value['returnedAt[after]'] = selectedDateReturned.value[0];
    params.value['returned  At[before]'] = selectedDateReturned.value[1];
  }


  if (asignmentStatus.value === "assigned") {
    params.value['exists[returnedAt]'] = false;
    params.value['exists[confirmedByEmployeeAt]'] = true;
  } else if (asignmentStatus.value === "returned") {
    params.value['exists[receivedBySystemsAt]'] = true;
  } else if (asignmentStatus.value === "returnRequest") {
    params.value['exists[returnedAt]'] = true;
    params.value['exists[receivedBySystemsAt]'] = false;
  } else if (asignmentStatus.value === "pending") {
    params.value['exists[returnedAt]'] = false;
    params.value['exists[confirmedByEmployeeAt]'] = false;

  }

  getMaterials();
}

const changeSearchParameters = () => {
  page.value = 1;
  search();
}



const closeDialogMaterialDelivery = (saved = null) => {
  materialDelivery.value = false;
  selectedMaterial.value = null;

  if (saved) {
    getMaterials();
  }
}
// eslint-disable-next-line no-unused-vars
const openDialogMaterialDelivery = (material = null) => {
  if (!material) {
    selectedMaterial.value = null;
    materialDelivery.value = true;
    return;
  }

  uiStore.startLoading();
  MaterialService.getMaterial(material.id)
    .then((res) => {
      if (res && res.status === 200) {
        selectedMaterial.value = res.data;
      } else {
        selectedMaterial.value = material;
      }
      materialDelivery.value = true;
    })
    .catch(() => {
      selectedMaterial.value = material;
      materialDelivery.value = true;
    })
    .finally(() => {
      uiStore.stopLoading();
    });
}

const getMaterials = () => {

  uiStore.startLoading();
  MaterialService.getMaterials(params.value)
    .then((res) => {
      if (res.status === 200) {
        totalResults.value = res.data['hydra:totalItems']
        filteredMaterial.value = res.data['hydra:member']
      }

      uiStore.stopLoading();
    }).catch(() => {
      uiStore.stopLoading();
    })
}

const getEmployees = (filters) => {

  params.value = {
    ...params.value,
    filter: filters,
    'order[name]': 'asc',
    page: 1,
    itemsPerPage: 999999
  };
  uiStore.startLoading();
  EmployeeService.getEmployees(params.value)
    .then((res) => {
      employees.value = res.data['hydra:member'];
      uiStore.stopLoading();
    })
    .catch(() => {
      uiStore.stopLoading();
    })
}
const filterEmployeesByName = (query) => {
  employeeSearchQuery.value = query;
}

const getMaterialsTypes = () => {
  // eslint-disable-next-line no-unused-vars
  const param = {
    'page': 1,
    'itemsPerPage': 99999,
  }
  uiStore.startLoading();
  MaterialTypeService.getMaterialTypes(param)
    .then((res) => {
      if (res.status === 200) {
        materialTypes.value = res.data['hydra:member']
      }
      uiStore.stopLoading();
    })
}


// const openDialgogDelete = (material) => {
//   showModalDelete.value = true;
//   selectedMaterial.value = material;
// }

const deleteMaterialSelected = (selected) => {

  MaterialService.discardMaterial(selected.id)
    .then((res) => {
      if (res === 201) {
        notification.addNotification({
          type: 'success',
          message: 'Creado el material correctamente',
          duration: 6000
        })
      }
    })
}

// eslint-disable-next-line no-unused-vars
const getTypeName = (name) => {
  const found = materialTypes.value.find(option => option['@id'] === name);
  return found ? found.name : null;
}

function formatDate(input) {
  const date = new Date(input);
  const pad = n => String(n).padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const getStatus = (value) => {
  const found = statusTypes.value.find(status => status.value === value)
  return found ? found.name : null
}

const returnStatusClass = (material) => {
  switch (detectStatusFromObject(material)) {
    case "pending":
      return "status-pending";
    case "assigned":
      return "status-assigned";
    case "returnRequest":
      return "status-returnRequest";
    case "returned":
      return "status-return";
    default:
      return "";
  }
};

const detectStatusFromObject = (obj) => {
  if (!obj || typeof obj !== "object") return null

  const returnedAt = obj.returnedAt
  const confirmedByEmployeeAt = obj.confirmedByEmployeeAt
  const receivedBySystemsAt = obj.receivedBySystemsAt

  // assigned
  if (returnedAt == null && confirmedByEmployeeAt != null) return "assigned"

  // returned
  if (receivedBySystemsAt != null) return "returned"

  // returnRequest
  if (returnedAt != null && receivedBySystemsAt == null) return "returnRequest"

  // pending
  if (returnedAt == null && confirmedByEmployeeAt == null) return "pending"

  return null
}

</script>

<template>
  <div>
    <header-title title="Sistemas" />
    <div class="d-flex flex-row justify-content-start">
      <IconBlueBox class="iconBlueBox" />
      <div class="title-text pl-4">
        Entrega de Material
      </div>
    </div>
    <el-row>
      <el-card class="card-search w-100 wback" body-style="padding:0">
        <div class="row">
          <div class="col-md-4">
            <div class="form-item date-picker mt-4 w-100 label-common pl-5">
              <label for="from-dat" class="w-100">Fecha de entrega (rango)</label>
              <el-date-picker id="from-dat" v-model="selectedDateAssigned" name="from-dat" type="daterange"
                style="width: 100%" placeholder="Fecha desde" format="DD/MM/YYYY" value-format="YYYY-MM-DD HH:mm"
                class="rangeMaterialPicker" :picker-options="{ firstDayOfWeek: 1 }" @change="changeSearchParameters" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-item date-picker mt-4 w-100 label-common pl-5">
              <label for="fto" class="w-100">Fecha de devolución (rango)</label>
              <el-date-picker id="fto" v-model="selectedDateReturned" name="from-date" type="daterange"
                placeholder="Fecha hasta" style="width: 100%" format="DD/MM/YYYY" value-format="YYYY-MM-DD HH:mm"
                class="rangeMaterialPicker" :picker-options="{ firstDayOfWeek: 1 }" @change="changeSearchParameters" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-item mt-4 w-100 label-common">
              <label for="employeesMat" class="w-100">Empleado al que se le entrega</label>
              <el-select id="employeesMat" v-model="employee" filterable clearable placeholder="TODOS"
                :filter-method="filterEmployeesByName" @change="changeSearchParameters">
                <el-option v-for="item in filteredEmployees" :key="item.id" :label="item.fullName"
                  :value="item.fullName" />
              </el-select>
            </div>
          </div>
          <div class="col-xl-4 col-md-6 col-lg-4">
            <div class="form-item mt-4 w-100 label-common pl-5">
              <label for="id-typesMat" class="w-100">Tipo de Material</label>
              <el-select id="id-typesMat" v-model="materialType" filterable clearable placeholder="TODOS"
                @change="changeSearchParameters">
                <el-option v-for="item in materialTypes" :key="item['@id']" :label="item.name" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="col-xl-4 col-md-6 col-lg-4">
            <div class="form-item mt-4 w-100 label-common">
              <label for="serialTag" class="w-100">Número de serie</label>
              <el-input id="serialTag" v-model="serialTag" class="search-input" placeholder="Código" clearable
                @change="changeSearchParameters" />
            </div>
          </div>
          <div class="col-xl-4 col-md-6 col-lg-4">
            <div class="form-item mt-4 w-100 label-common">
              <label for="petitionStatus" class="w-100">Estado de la asignación</label>
              <el-select id="petitionStatus" v-model="asignmentStatus" filterable clearable placeholder="TODOS"
                @change="changeSearchParameters">
                <el-option v-for="item in statusTypes" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="col-xl-12 d-flex justify-content-end align-items-center">
            <div class="align-content-center btn-group-responsive">
              <button class="btn btn_red btn__new" style="width: 200px;" @click="openDialogMaterialDelivery()">
                Nueva Asignación
              </button>
              <button class="btn btn_yellow btn-search btn__search" @click="changeSearchParameters()">
                Buscar
              </button>
            </div>
          </div>
        </div>
      </el-card>
    </el-row>
    <div class="table table-material table-not-mobile">
      <div v-if="filteredMaterial && filteredMaterial.length > 0">
        <table>
          <thead>
            <tr class="justify-content-start gap-2">
              <th>
                FECHA DE ENTREGA
              </th>
              <th>
                CONFIRMACIÓN DE ENTREGA
              </th>
              <th>
                SOLICITUD DEVOLUCIÓN
              </th>
              <th>
                CONFIRMACIÓN DE DEVOLUCIÓN
              </th>
              <th>
                EMPLEADO
              </th>
              <th>
                TIPO
              </th>
              <th>
                NÚMERO DE SERIE
              </th>
              <th>
                ESTADO
              </th>
              <th class="actions-header">
                ACCIONES
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="material in filteredMaterial" :key="material.id" class="pointer"
              @click="openDialogMaterialDelivery(material)">
              <td>
                {{ material.assignedAt ? formatDate(material.assignedAt) : '' }}
              </td>
              <td>
                <!-- Fecha RECEPCION -->
                {{ material.confirmedByEmployeeAt ? formatDate(material.confirmedByEmployeeAt) : '' }}
              </td>
              <td>
                <!-- Fecha devolución -->
                {{ material.returnedAt ? formatDate(material.returnedAt) : '' }}
              </td>
              <td>
                <!-- Fecha devolución -->
                {{ material.receivedBySystemsAt ? formatDate(material.receivedBySystemsAt) : '' }}
              </td>
              <td>
                <!-- Empleado -->
                {{ material.employee ? material.employee.fullName : '' }}
              </td>
              <td>
                <!-- Tipo -->
                <!-- {{ material.material ? getTypeName(material.material.type) : '' }} -->
                {{ material.material ? material.material.type.name : '' }}
              </td>
              <td>
                <!-- Numero de serie -->
                {{ material.material ? material.material.serialTag : '' }}
              </td>
              <td class="status-cell">
                <!-- Estado -->
                <div class="d-flex justify-content-center">
                  <span :class="returnStatusClass(material)" v-if="material">
                    {{ getStatus(detectStatusFromObject(material)) }}
                  </span>
                </div>
              </td>
              <td class="actions-cell">
                <div class="buttons d-inline-flex">
                  <!-- <div class="pointer">
                    <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Dar de baja"
                      @click="openDialgogDelete(material)">
                      <font-awesome-icon icon="circle" style="color:red" />
                      <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                    </font-awesome-layers>
                  </div> -->
                  <div class="pointer">
                    <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Editar"
                      @click.stop="openDialogMaterialDelivery(material)">
                      <font-awesome-icon icon="circle" style="color: #f7d20e" />
                      <font-awesome-icon icon="plus" class="fa-inverse" transform="shrink-6" />
                    </font-awesome-layers>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado material según los filtros especificados...</h5>
      </div>
      <SharedElementPagination class="pagination" v-model:current-page="page" :total="totalResults"
        v-model:page-size="itemsPerPage" style="padding: 0px 0px 20px 0px;" @change="page = $event; search()"
        show-always />
    </div>
    <div class="table-mobile material-delivery-mobile">
      <div v-if="filteredMaterial && filteredMaterial.length > 0">
        <div v-for="material in filteredMaterial" :key="material.id">
          <el-row class="mt-4">
            <el-card class="card-material-delivery-item pointer" @click="openDialogMaterialDelivery(material)">
              <div class="row d-flex">
                <div class="el-col-xs-24 material-delivery-main-row">
                  <span class="material-delivery-item-span">Fecha de entrega: </span>
                  <span>{{ material.assignedAt ? formatDate(material.assignedAt) : '' }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.confirmedByEmployeeAt">
                  <span class="material-delivery-item-span">Confirmación de entrega: </span>
                  <span>{{ formatDate(material.confirmedByEmployeeAt) }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.returnedAt">
                  <span class="material-delivery-item-span">Solicitud devolución: </span>
                  <span>{{ formatDate(material.returnedAt) }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.receivedBySystemsAt">
                  <span class="material-delivery-item-span">Confirmación de devolución: </span>
                  <span>{{ formatDate(material.receivedBySystemsAt) }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.employee">
                  <span class="material-delivery-item-span">Empleado: </span>
                  <span>{{ material.employee.fullName }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.material && material.material.type">
                  <span class="material-delivery-item-span">Tipo: </span>
                  <span>{{ material.material.type.name }}</span>
                </div>
                <div class="el-col-xs-24" v-if="material.material && material.material.serialTag">
                  <span class="material-delivery-item-span">Número de serie: </span>
                  <span>{{ material.material.serialTag }}</span>
                </div>
                <div class="el-col-xs-24 material-delivery-status-row">
                  <span :class="returnStatusClass(material)" v-if="material">
                    {{ getStatus(detectStatusFromObject(material)) }}
                  </span>
                </div>
              </div>
            </el-card>
          </el-row>
        </div>
      </div>
      <div v-else>
        <h5>No se han encontrado material según los filtros especificados...</h5>
      </div>
      <SharedElementPagination class="pagination" v-model:current-page="page" :total="totalResults"
        v-model:page-size="itemsPerPage" style="padding: 0px 0px 20px 0px;" @change="page = $event; search()"
        show-always />
    </div>
    <div class="row d-flex justify-content-end fixed-bottom p-4">

    </div>
    <!-- Modal Entrega de material -->
    <el-dialog style="border-radius: 20px;" v-model="materialDelivery" width="601" class="material-delivery-modal material-modal" :show-close="false"
      :lock-scroll="true" @close="closeDialogMaterialDelivery">
      <MaterialDeliveryDialog v-if="materialDelivery" :material="selectedMaterial" :employee="false"
        @close-dialog="closeDialogMaterialDelivery" />
    </el-dialog>
    <!-- Modal Eliminación de material -->
    <SharedDeleteConfirmDialog class="material-modal" v-model="showModalDelete" title="Eliminar asignación de material"
      message="¿Desea eliminar esta asignación de material?" @confirm="deleteMaterialSelected(selectedMaterial)"
      @cancel="selectedEmployee = null" />

  </div>
</template>

<style lang="scss" scoped>
.btn__search,
.btn__new {
  width: 200px;
  height: 3em;
  margin-top: 24px;
}

.iconBlueBox {
  width: 30px;
  fill: $bg-blue;
}

.btn-group-responsive {
  display: flex;
  gap: 1rem;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;

    button {
      width: 100% !important;
      margin-top: 0px !important;
    }
  }
}

.status-return,
.status-assigned,
.status-returnRequest,
.status-pending {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 0.95rem;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
}

.status-pending {
  background-color: #f1c40f;
}

.status-assigned {
  background-color: #474CE6;
}

.status-return {
  background-color: #27ae60;
}

.status-returnRequest {
  background-color: #E53935;
}

.status-cell {
  min-width: 140px;
  vertical-align: middle;
}

.actions-header,
.actions-cell {
  text-align: center;
  vertical-align: middle;
  width: 82px;
}

.status-return,
.status-assigned,
.status-returnRequest,
.status-pending {
  max-width: 100%;
  white-space: normal;
}

.actions-cell .buttons {
  justify-content: center;
  width: 100%;
}

.card-material-delivery-item {
  border-radius: 16px;
  font-size: 15px;
  position: relative;
  width: 100%;
}

.card-material-delivery-item:deep(.el-card__body) {
  padding: 18px 16px 18px 16px;
}

.material-delivery-item-span {
  color: $bg-blue;
  font-weight: 800;
}

.material-delivery-status-row {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.material-delivery-mobile {
  margin-top: 10px;
}

:deep(.material-delivery-modal) {
  max-width: calc(100vw - 24px);
}

:deep(.el-range-editor.el-input__wrapper) {
  border-radius: 20px !important;
}

@media(min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media(max-width: 767px) {
  .table-not-mobile {
    display: none;
  }

  .title-text {
    font-size: clamp(2rem, 10vw, 3.2rem);
    line-height: 0.95;
  }

  .card-search {
    margin-top: 12px;
  }

  .card-search:deep(.el-card__body) {
    padding: 16px 12px !important;
  }

  .card-search .row {
    margin-left: 0;
    margin-right: 0;
  }

  .card-search [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
  }

  .card-search .form-item {
    margin-top: 0.75rem !important;
    padding-left: 0 !important;
  }

  .card-search .el-select,
  .card-search .el-input,
  .card-search .el-date-editor {
    width: 100% !important;
  }

  .btn-group-responsive {
    padding-top: 6px;
  }

  .material-delivery-mobile .pagination {
    padding-bottom: 12px !important;
  }
}
</style>
